import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../../config';
import { AppLocalStorage } from '../../data/LocalStorage/AppLocalStorage';
import { NavSections } from '../navigation/NavSections';
function NoMatch() {
    const navigate = useNavigate();
    const location = useLocation();
    AppLocalStorage.set(NavSections.HOME, 'lastViewedRoute', '');
    return (_jsxs(Stack, { height: "100cqh", justifyContent: "center", alignItems: "center", gap: 1, children: [_jsxs(Typography, { variant: "h4", children: ["Couldn't find ", _jsx("code", { children: location.pathname })] }), _jsx(Stack, { direction: "row", children: _jsx(Button, { type: "submit", variant: "contained", color: "primary", onClick: () => navigate(config.app.initialRedirect), children: "Back To Dashboard" }) })] }));
}
export default NoMatch;
